import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  Inject
} from '@angular/core';

require('./location-to-place.scss');
@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  selector: 'app-location-to-place',
  templateUrl: './location-to-place.html',
})
export class LocationToPlaceComponent implements OnChanges {
  @Input() location: any;

  public place: string;
  public loading: boolean;

  constructor(
    @Inject('latLngToAddress') private latLngToAddress: any
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.location && this.location) {
      this.loading = true;
      this.latLngToAddress(this.location.latitude, this.location.longitude)
        .then((place: string) => {
          this.place = place;
        })
        .catch((error: any) => {
        })
        .finally(() => {
          this.loading = false;
        });
    } else if (!this.location) {
      this.place = undefined;
    }
  }
}
